import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  withStyles,
  // FormHelperText,
} from '@material-ui/core'
import { changeFieldValues, saveFieldValues } from 'actions/template'
import styles from './styles'
import { capitalize } from 'lodash'
import Button from 'components/theme/Button'
import ColorPicker from 'components/AddOrEditFormPage/Form/ColorPicker'
import language from 'utils/vast-languagepack'

const SocialMediaInput = connect(
  (state, { type }) => ({ value: state.email.socialMediaLinkValues[type] }),
  (dispatch) => bindActionCreators({ changeFieldValues }, dispatch),
)(
  withStyles(styles)(
    class TemplateName extends Component {
      componentDidMount() {
        this.forceUpdate()
      }

      render() {
        return (
          <FormControl fullWidth variant="outlined">
            <InputLabel
              ref={(ref) => {
                this.labelRef = ReactDOM.findDOMNode(ref)
              }}
              htmlFor={`socialMediaLinkField${this.props.type}`}
              shrink
              style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
            >
              {`Your ${capitalize(this.props.type)} URL`}
            </InputLabel>
            <OutlinedInput
              labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
              value={this.props.value}
              onChange={(e) =>
                this.props.changeFieldValues(
                  e.target.value,
                  'socialMediaLinkValues',
                  this.props.type,
                )
              }
              notched
              classes={{
                notchedOutline: this.props.classes.notchedOutline,
              }}
            />
            {/* <FormHelperText>{this.props.helperText}</FormHelperText> */}
          </FormControl>
        )
      }
    },
  ),
)

const ColorInput = connect(
  (state, { type }) => ({ value: state.email.socialMediaColorValues[type] }),
  (dispatch) => bindActionCreators({ changeFieldValues }, dispatch),
)(
  withStyles(styles)(
    class TemplateName extends Component {
      componentDidMount() {
        this.forceUpdate()
      }

      render() {
        return (
          <FormControl fullWidth variant="outlined">
            <InputLabel
              ref={(ref) => {
                this.labelRef = ReactDOM.findDOMNode(ref)
              }}
              htmlFor={`socialMediaColorField${this.props.type}`}
              shrink
              style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
            >
              {`${capitalize(this.props.type)} Color`}
            </InputLabel>
            <OutlinedInput
              labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
              value={this.props.value}
              onChange={(e) =>
                this.props.changeFieldValues(
                  e.target.value,
                  'socialMediaColorValues',
                  this.props.type,
                )
              }
              notched
              classes={{
                notchedOutline: this.props.classes.notchedOutline,
              }}
              endAdornment={
                <ColorPicker
                  value={this.props.value}
                  handleFormValueChange={(value) =>
                    this.props.changeFieldValues(
                      value,
                      'socialMediaLinkValues',
                      this.props.type,
                    )
                  }
                />
              }
            />
            {/* <FormHelperText>{this.props.helperText}</FormHelperText> */}
          </FormControl>
        )
      }
    },
  ),
)

export default connect(null, (dispatch) =>
  bindActionCreators({ saveFieldValues }, dispatch)
)(({ saveFieldValues }) => (
  <div style={{ textAlign: 'right' }}>
    {['facebook', 'instagram', 'twitter'].map((type) => (
      <div style={{ marginBottom: 8 }} key={`${type}URLField`}>
        <SocialMediaInput type={type} />
      </div>
    ))}
    {[/* 'icon',  */ 'background'].map((type) => (
      <div style={{ marginBottom: 8 }} key={`${type}ColorField`}>
        <ColorInput type={type} />
      </div>
    ))}
    <Button
      onClick={() => saveFieldValues('socialMediaLinkValues')}
      color='secondary'
      variant='contained'
    >
      {language.editor.socialMedia}
    </Button>
  </div>
));
